var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpKertovakuvitus28813(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 288 288",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3,.cls-5{fill:#fff;}.cls-2{fill:none;}.cls-2,.cls-3,.cls-5{stroke:#6e6e6e;stroke-width:1.25px;}.cls-2,.cls-3{stroke-linecap:round;stroke-linejoin:round;}.cls-4{fill:#6e6e6e;}.cls-5{stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 288,
    height: 288
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M194.31,119.45c0,56.35-23,55.47-51,55.47s-51,.88-51-55.47c0-45.32.16-90.4,51-90.4S194.31,74.13,194.31,119.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M136.82,77.6c10.24-4.65,18.19-25,18.19-25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.6,81.75C129.85,77.11,136.39,60,136.39,60"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.86,83.51c8.12-4.62,13.59-16.77,13.59-16.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M88.29,193.24c0-31.17,24.64-40,55-40s55,8.85,55,40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M198.34,193.24c0-31.17-24.63-40-55-40s-55,8.85-55,40"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M130.32,140.2v14c0,8.67,6.83,12.53,13,12.53s13-3.86,13-12.53v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.32,140.2v14c0,8.67,6.83,12.53,13,12.53s13-3.86,13-12.53v-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M180.62,110.61c5.3.77,7-3.43,8.55-8.56,1.88-6.26-.46-9.87-5.76-10.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.62,110.61c5.3.77,7-3.43,8.55-8.56,1.88-6.26-.46-9.87-5.76-10.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106,110.61c-5.3.77-7-3.43-8.55-8.56-1.88-6.26.46-9.87,5.77-10.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M106,110.61c-5.3.77-7-3.43-8.55-8.56-1.88-6.26.46-9.87,5.77-10.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M183.3,81.84c0-.49,0-1,0-1.44-3.05-4-6.61-11.68-11.13-22.84,0,0-21.12,23.25-68.81,25.87.16,26.78,4.29,38.08,11.61,47.38,7.47,9.47,19.8,16.61,28.37,16.61s22.2-7.12,28.88-16.61,11.11-25.07,11.11-49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M183.3,81.84c0-.49,0-1,0-1.44-3.05-4-6.61-11.68-11.13-22.84,0,0-21.12,23.25-68.81,25.87.16,26.78,4.29,38.08,11.61,47.38,7.47,9.47,19.8,16.61,28.37,16.61s22.2-7.12,28.88-16.61S183.3,105.74,183.3,81.84Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "142.55 98.72 140.65 114.52 145.98 114.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M149,121.84a5.92,5.92,0,0,1-11.31,0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 161.29,
    y1: 79.33,
    x2: 168.7,
    y2: 79.33
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 112.66,
    y1: 89.15,
    x2: 114.61,
    y2: 92.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 116.19,
    y1: 87.11,
    x2: 118.34,
    y2: 90.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M127.32,99.57a5,5,0,1,1-5-5,5,5,0,0,1,5,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M130.52,97.76c0-3.28-3.61-7.2-9.38-7.2-3.53,0-6.34,1.25-7.84,3.36"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 174.07,
    y1: 89.15,
    x2: 172.11,
    y2: 92.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 170.54,
    y1: 87.11,
    x2: 168.39,
    y2: 90.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M169.53,99.57a5,5,0,1,1-5-5,5,5,0,0,1,5,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.06,97.76c0-3.28-3.62-7.2-9.38-7.2-3.54,0-6.34,1.25-7.84,3.36"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 69.12,
    y: 163.86,
    width: 148.4,
    height: 85.06,
    rx: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.54,251.5H217.09a.42.42,0,0,1,.42.42v2.41a1.34,1.34,0,0,1-1.34,1.34H70.46a1.34,1.34,0,0,1-1.34-1.34v-2.41A.42.42,0,0,1,69.54,251.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M99.33,83.51s-1-57.23,43.43-57.23c38,0,43.44,33.68,43.44,57.23h-2.9s3.25-54.46-40-54.46-41.89,54.46-41.89,54.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 94.25,
    y: 82.45,
    width: 11.62,
    height: 34.24,
    rx: 5.81
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 179.04,
    y: 82.45,
    width: 12.21,
    height: 34.24,
    rx: 6.11
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.06,116.7s10.6,20.71,40.59,20.71V135.5s-28.43-.7-38-18.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 139.85,
    y: 130.71,
    width: 4.82,
    height: 11.52,
    rx: 2.41,
    transform: "translate(278.73 -5.79) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpKertovakuvitus28813);
export default __webpack_public_path__ + "static/media/OP_kertovakuvitus_288-13.e3880a5ace348fb6a4fdf74df58f4f33.svg";
export { ForwardRef as ReactComponent };